/* @generated by scripts/buildLegacyRepaint.ts from scripts/legacyColorMap.ts — do not edit by hand. */
/* Regenerate: npm run build:legacy-repaint   Verify: npm run guard:legacy-repaint */

export interface LegacyWasNowRow {
  was: string;
  families: string[];
  paints: string;
  shades: string;
  paper: string;
  night: string;
  ruling: string | null;
  note: string;
}

/** What each legacy color class paints now. The same table the repaint sheet is generated from. */
export const LEGACY_WAS_NOW: LegacyWasNowRow[] = [
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A fill",
    "shades": "50",
    "paper": "--active-dim",
    "night": "--active-dim",
    "ruling": null,
    "note": "Selected or tinted ground. The thinnest tint, so quiet words on it still clear 4.5:1 on Paper."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A fill",
    "shades": "100",
    "paper": "--active-tint",
    "night": "--active-tint",
    "ruling": null,
    "note": "A tinted chip or the hover of a selected ground."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A fill",
    "shades": "200",
    "paper": "--active-lift",
    "night": "--active-lift",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A fill",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": null,
    "note": "A weak solid: the disabled form of a slate button."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A fill",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": "D1",
    "note": "Owner ruling D1: the primary button is slate. White text on it passes in both modes (5.2:1 light, 8.6:1 dark)."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": null,
    "note": "Words on a dark fill."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "Words",
    "shades": "300–600",
    "paper": "--text-ter",
    "night": "--text-ter",
    "ruling": "D4",
    "note": "Owner ruling D4: a link is the quiet text color, underlined on hover. Gold stays for emphasis."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "Words",
    "shades": "700",
    "paper": "--text-sec",
    "night": "--text-sec",
    "ruling": null,
    "note": "The hover of a link, or words on a tint: one step stronger."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "Words",
    "shades": "800–900",
    "paper": "--text-pri",
    "night": "--text-pri",
    "ruling": null,
    "note": "Strong words on a tint."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A border or line",
    "shades": "50–200",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "Soft accent border."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A border or line",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": null,
    "note": "The hover of a soft border: halfway to the active one."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "Active border. In Night a border color needs an inline style or a sheet rule."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Sage green",
    "families": [
      "slate-blue",
      "primary"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A fill",
    "shades": "50",
    "paper": "--active-dim",
    "night": "--active-dim",
    "ruling": null,
    "note": "Selected or tinted ground. The thinnest tint, so quiet words on it still clear 4.5:1 on Paper."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A fill",
    "shades": "100",
    "paper": "--active-tint",
    "night": "--active-tint",
    "ruling": null,
    "note": "A tinted chip or the hover of a selected ground."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A fill",
    "shades": "200",
    "paper": "--active-lift",
    "night": "--active-lift",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A fill",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": null,
    "note": "A weak solid: the disabled form of a slate button."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A fill",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "A solid fill. White text on it passes in both modes."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": null,
    "note": "Words on a dark fill."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "Words",
    "shades": "300–600",
    "paper": "--text-ter",
    "night": "--text-ter",
    "ruling": null,
    "note": "Quiet words. Slate is not a word color in Night."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "Words",
    "shades": "700",
    "paper": "--text-sec",
    "night": "--text-sec",
    "ruling": null,
    "note": "The hover of a link, or words on a tint: one step stronger."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "Words",
    "shades": "800–900",
    "paper": "--text-pri",
    "night": "--text-pri",
    "ruling": null,
    "note": "Strong words on a tint."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A border or line",
    "shades": "50–200",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "Soft accent border."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A border or line",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": null,
    "note": "The hover of a soft border: halfway to the active one."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "Active border. In Night a border color needs an inline style or a sheet rule."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Consulting slate",
    "families": [
      "consulting-slate-blue"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A fill",
    "shades": "50",
    "paper": "--active-dim",
    "night": "--active-dim",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A fill",
    "shades": "100",
    "paper": "--active-tint",
    "night": "--active-tint",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A fill",
    "shades": "200",
    "paper": "--active-lift",
    "night": "--active-lift",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A fill",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A fill",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "Words",
    "shades": "300–600",
    "paper": "--text-ter",
    "night": "--text-ter",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "Words",
    "shades": "700",
    "paper": "--text-sec",
    "night": "--text-sec",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "Words",
    "shades": "800–900",
    "paper": "--text-pri",
    "night": "--text-pri",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A border or line",
    "shades": "50–200",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A border or line",
    "shades": "300",
    "paper": "--slate at 55%",
    "night": "--slate at 55%",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": "D6",
    "note": "Owner ruling D6: there is no informational blue. Notices take slate."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Frosted Sky",
    "families": [
      "sky"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--slate",
    "night": "--slate",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A fill",
    "shades": "50–300",
    "paper": "--green-dim",
    "night": "--green-dim",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A fill",
    "shades": "400–900",
    "paper": "--green",
    "night": "--green",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": null,
    "note": "Words on a dark fill."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "Words",
    "shades": "300–700",
    "paper": "--green",
    "night": "--text-ter",
    "ruling": null,
    "note": "Forest as words is too dim in Night."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "Words",
    "shades": "800–900",
    "paper": "--text-pri",
    "night": "--text-pri",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A border or line",
    "shades": "50–300",
    "paper": "--green at 35%",
    "night": "--green at 35%",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--green",
    "night": "--green",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--green at 35%",
    "night": "--green at 35%",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Alpine green",
    "families": [
      "alpine-green",
      "sage",
      "ocean",
      "olive"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--green",
    "night": "--green",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "50",
    "paper": "--bg",
    "night": "--bg-raised",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "100",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "200",
    "paper": "--rule",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "300",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "400–500",
    "paper": "--text-dim",
    "night": "--bg-raised",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "600–700",
    "paper": "--text-sec",
    "night": "--bg-raised",
    "ruling": null,
    "note": "A dark panel: ink on Paper, the raised ground in Night."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "800",
    "paper": "--text-pri",
    "night": "--surface",
    "ruling": null,
    "note": "A dark panel: ink on Paper, the surface in Night."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A fill",
    "shades": "900",
    "paper": "--text-pri",
    "night": "--bg",
    "ruling": null,
    "note": "A dark panel: ink on Paper, the ground in Night."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "--bg",
    "night": "--text-pri",
    "ruling": null,
    "note": "Pale words on a dark panel."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "300–400",
    "paper": "--text-dim",
    "night": "--text-dim",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "500",
    "paper": "--text-dim",
    "night": "--text-ter",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "600",
    "paper": "--text-ter",
    "night": "--text-sec",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "700",
    "paper": "--text-sec",
    "night": "--text-sec",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "Words",
    "shades": "800–900",
    "paper": "--text-pri",
    "night": "--text-pri",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A border or line",
    "shades": "50–200",
    "paper": "--rule",
    "night": "--rule",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A border or line",
    "shades": "300–500",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A border or line",
    "shades": "600–700",
    "paper": "--text-ter",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A border or line",
    "shades": "800–900",
    "paper": "--text-ter",
    "night": "--text-pri",
    "ruling": null,
    "note": ""
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A ring",
    "shades": "50–900",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": "A neutral ring is a border."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "The first grays",
    "families": [
      "granite-gray",
      "charcoal"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--text-pri",
    "night": "--bg",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A fill",
    "shades": "50–200",
    "paper": "--mustard-dim",
    "night": "--mustard-dim",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A fill",
    "shades": "300–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": null,
    "note": "Words on a dark fill."
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "Words",
    "shades": "300–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A border or line",
    "shades": "50–300",
    "paper": "--mustard at 35%",
    "night": "--mustard at 35%",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--mustard at 35%",
    "night": "--mustard at 35%",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Electric Mustard",
    "families": [
      "electric-mustard",
      "amber",
      "ochre"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A fill",
    "shades": "50–200",
    "paper": "--coral-dim",
    "night": "--coral-dim",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A fill",
    "shades": "300–900",
    "paper": "--coral",
    "night": "--coral",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "Words",
    "shades": "50–200",
    "paper": "white",
    "night": "white",
    "ruling": null,
    "note": "Words on a dark fill."
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "Words",
    "shades": "300–900",
    "paper": "--coral",
    "night": "--coral",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A border or line",
    "shades": "50–300",
    "paper": "--coral at 35%",
    "night": "--coral at 35%",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--coral",
    "night": "--coral",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A ring",
    "shades": "50–300",
    "paper": "--coral at 35%",
    "night": "--coral at 35%",
    "ruling": null,
    "note": "A pale ring is a soft border."
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A ring",
    "shades": "400–900",
    "paper": "--mustard",
    "night": "--mustard",
    "ruling": null,
    "note": "Focus or selection. The system's focus is gold (mono/primitives)."
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Luminous Coral",
    "families": [
      "luminous-coral",
      "coral",
      "terracotta",
      "burnt"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--coral",
    "night": "--coral",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A fill",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A fill",
    "shades": "400–900",
    "paper": "--text-pri",
    "night": "--text-sec",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "Words",
    "shades": "50–900",
    "paper": "--text-sec",
    "night": "--text-sec",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A border or line",
    "shades": "50–300",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A border or line",
    "shades": "400–900",
    "paper": "--text-ter",
    "night": "--text-ter",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A ring",
    "shades": "50–900",
    "paper": "--rule-bright",
    "night": "--rule-bright",
    "ruling": null,
    "note": ""
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A gradient stop",
    "shades": "50–300",
    "paper": "--surface",
    "night": "--surface",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  },
  {
    "was": "Earth tones",
    "families": [
      "sienna",
      "brown"
    ],
    "paints": "A gradient stop",
    "shades": "400–900",
    "paper": "--text-pri",
    "night": "--text-sec",
    "ruling": null,
    "note": "No gradients. Make the element a flat fill."
  }
];
